export const newsletterSubscriptionConstants = {
    SUBSCRIBE_SET_FORM_VALUES: 'SUBSCRIBE_SET_FORM_VALUES',
    SUBSCRIBE_RESET_FORM_VALUES: 'SUBSCRIBE_RESET_FORM_VALUES',
    SUBSCRIBE_REQUEST: 'SUBSCRIBE_REQUEST',
    SUBSCRIBE_SUCCESS: 'SUBSCRIBE_SUCCESS',
    SUBSCRIBE_FAILURE: 'SUBSCRIBE_FAILURE'
}
